import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { GraphApiService, UserGraph } from '../graph/graph-api.service';

@Injectable({
  providedIn: 'root'
})
export class GraphService {

  private readonly graphApi = inject(GraphApiService);

  private readonly USER_DATA_KEY = 'graph-user-data';
  private readonly USER_PIC_KEY = 'graph-user-pic';

  readonly userStorageData = this.getSavedUserData();
  readonly pic = this.getSavedProfilePic();
  readonly userGraphData = signal<UserGraph | null>(null);

  /**
   * Save user data from Microsoft Graph to local storage and variable.
   */
  async saveGraphUserData() {
    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        const userData = await firstValueFrom(this.graphApi.getMe());
        const profilePic = await this.graphApi.getProfilePic();
        this.userGraphData.set(userData);

        // Salva localmente se mudou
        const currentUserSavedData = this.getSavedUserData();
        if (!currentUserSavedData || JSON.stringify(currentUserSavedData) !== JSON.stringify(userData)) {
          localStorage.setItem(this.USER_DATA_KEY, JSON.stringify(userData));
        }

        const currentUserProfilePic = this.getSavedProfilePic();
        if (!currentUserProfilePic || currentUserProfilePic !== profilePic) {
          localStorage.setItem(this.USER_PIC_KEY, profilePic);
        }
      } catch (error) {
        console.error('Erro ao salvar dados do Graph:', error);
      }
    }
  }

  /**
   * Get saved user data from local storage.
   * @returns User data or null if not found.
   */
  getSavedUserData(): UserGraph | null {
    const savedData = localStorage.getItem(this.USER_DATA_KEY);
    return savedData ? JSON.parse(savedData) : null;
  }

  /**
   * Get saved profile picture from local storage.
   * @returns Profile picture or null if not found.
   */
  getSavedProfilePic(): string | null {
    return localStorage.getItem(this.USER_PIC_KEY);
  }

  /** SSB = employeeId */
  getCurrentSsb(): string | null {
    const live = this.userGraphData();
    const data = live ?? this.getSavedUserData();
    const ssb = data?.employeeId;
    return typeof ssb === 'string' ? ssb.trim() : null;
  }
}
